<main class="container-fluid">
  <app-admin-sidebar></app-admin-sidebar>
  <div class="profile-container gap-3">
    <div class="w-100 mb-5" *ngIf="event && organization">
      <a class="text-decoration-none" routerLink="../">
        <i class="bi bi-arrow-left me-2"></i>Terug naar overzicht
      </a>
      <h1 class="subtitle mt-3">Activiteit beheren</h1>
      <table class="profile-details">
        <tr>
          <td class="profile-text">Naam</td>
          <td>{{ event.name }}</td>
        </tr>
        <tr>
          <td class="profile-text">Categorie</td>
          <td>{{ event.category }}</td>
        </tr>
        <tr>
          <td class="profile-text">Adres</td>
          <td>{{ event.address.streetName }} {{ event.address.houseNumber}}, {{ event.address.zipcode }}</td>
        </tr>
        <tr>
          <td class="profile-text">Plaats</td>
          <td>{{ event.address.location }}</td>
        </tr>
        <tr>
          <td class="profile-text">Organisatie</td>
          <td><a routerLink="/admin/beheer-organisaties/{{ organization.id }}">{{ organization.name }}</a></td>
        </tr>
        <tr>
          <td class="profile-text">Begin</td>
          <td>{{ event.start.toMillis() | date:'d MMMM H:mm' }}</td>
        </tr>
        <tr>
          <td class="profile-text">Einde</td>
          <td>{{ event.end.toMillis() | date:'d MMMM H:mm' }}</td>
        </tr>
        <tr>
          <td class="profile-text">Beschrijving</td>
          <td>{{ event.description }}</td>
        </tr>
      </table>
      <div class="action-buttons">
        <div class="row button-row">
          <button class="btn btn-primary profile-button mt-3" (click)="toActivity()">
            Live activiteit bekijken
          </button>
        </div>
        <div class="row button-row">
          <button class="btn btn-primary profile-button mt-3" (click)="editActivity()">
            Live activiteit wijzigen
          </button>
        </div>
      </div>
    </div>
  </div>
</main>

